export default __webpack_public_path__ + "static/Top-ski-holiday-locations-f5f4cf766707b6ecc36b12ca180b660d.jpg";